<section class="w-full text-fg">
  <ui-page-header title="Provider Balances" subtitle="Ledger, calculated, and reconciliation balances per API provider and currency.">
    <button uiButton variant="outline" size="sm" type="button" title="Refresh" (click)="reload()">
      <ng-icon name="lucideRefreshCw" size="16" />
    </button>
  </ui-page-header>

  @if (loading()) {
    <div class="flex flex-col items-center gap-3 p-12 text-muted">
      <ui-spinner />
      <p class="m-0">Loading provider balances…</p>
    </div>
  } @else if (error(); as err) {
    <ui-alert variant="danger">
      <p class="m-0 font-semibold">{{ err }}</p>
    </ui-alert>
  } @else {
    <div uiTableWrap>
      <table uiTable>
        <thead>
          <tr>
            <th>Provider</th>
            <th>Currency</th>
            <th>Entity</th>
            <th>Account balance</th>
            <th>Calculated</th>
            <th>Reconciliation</th>
            <th>Calc vs ledger</th>
            <th>Recon vs ledger</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          @for (row of rows(); track row.api_provider.id + (row.currency_code || '')) {
            <tr>
              <td>
                <strong>{{ row.api_provider.code }}</strong>
                <div class="text-xs text-muted">{{ row.api_provider.name }}</div>
              </td>
              <td><ui-badge variant="brand">{{ row.currency_code || '—' }}</ui-badge></td>
              <td>{{ row.financial_entity?.code || '—' }}</td>
              <td>{{ formatAmount(row.account_balance, row.currency_code) }}</td>
              <td>{{ formatAmount(row.calculated_balance, row.currency_code) }}</td>
              <td>{{ formatAmount(row.reconciliation_balance, row.currency_code) }}</td>
              <td [class.text-danger-fg]="row.calculated_vs_ledger.startsWith('-')">
                {{ formatAmount(row.calculated_vs_ledger, row.currency_code) }}
              </td>
              <td [class.text-danger-fg]="row.reconciliation_vs_ledger.startsWith('-')">
                {{ formatAmount(row.reconciliation_vs_ledger, row.currency_code) }}
              </td>
              <td>
                <a [routerLink]="hubLink(row)" [queryParams]="hubQueryParams(row)" class="text-[0.8rem] font-bold text-primary no-underline hover:underline">Open hub</a>
              </td>
            </tr>
          } @empty {
            <tr><td colspan="9">No active API providers with accepted currencies.</td></tr>
          }
        </tbody>
      </table>
    </div>
  }
</section>
